
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {ErrorMessage, Field, Formik} from "formik";
import * as yup from "yup";

import * as proyectAction from "../store/actions/proyectAction";
import { Button } from 'primereact/button';
import { useHistory } from 'react-router';
import { apiUsuario, rutaConfig } from '../Config/const';
import AxiosConexionConfig from './Conexion/AxiosConexionConfig';
import { Dropdown } from 'primereact/dropdown';

const AddUser=(props)=> {
    const history = useHistory();
    const initialValues = {
        correo: "",
        nombre: "",
        rol:"",
    };
    const rolOptions=["usuario","administrador","tecnico"];
    const [rol, setRol]=useState(rolOptions[0])
    //Obtener usuarios desde la api y definir usuario actual
    //props.setProyectPlantaVisible(false); 
    //props.setBreadCrumb([{label: props.breadCrumbLabel[0], url: props.breadCrumbUrl[0]},{label:props.breadCrumbLabel[1], url: props.breadCrumbUrl[1]}])

    useEffect(() => {
        props.setProyectPlantaVisible(false); 
        props.setBreadCrumb([{label: props.breadCrumbLabel[0], url: props.breadCrumbUrl[0]},{label:props.breadCrumbLabel[1], url: props.breadCrumbUrl[1]}])
        // eslint-disable-next-line
    },[]);
    
    async function handleSubmit(values, errors) {
        //console.log(values)
        values.rol=rol;
        //console.log(values)
        const url = apiUsuario;
        try {
            AxiosConexionConfig.post(url, values);
            //console.log(user);
            history.push(rutaConfig)
        } catch (e) {
            console.log(e);
        }
    }
    const onRolChenge = (e) => {
        setRol(e.value);
    }
   return(
       <div className="card formUser">
           <div className="center">
                    <img style={{width:"100px"}} src='assets/layout/images/profile.png' alt="Profile" />
                </div>
           <Formik initialValues={initialValues} onSubmit={handleSubmit}
                    validationSchema={validationSchema}>
                    {({values, errors, touched, focus, onBlur, handleBlur, handleChange, handleSubmit, onFocus}) => (
                        <form onSubmit={handleSubmit} className="register-form">
                            <ErrorMessage name="auth" className="invalid-feedback">{message =>
                                <div>{message}</div>}</ErrorMessage>
                             <div className="card p-fluid marginLeft20px marginRight20px">
                                <div className="p-formgrid p-grid">
                                    <div className="p-field p-col p-md-6 p-col-12">
                                        <label htmlFor={"nombre"} className="text textMarca">Nombre:</label>
                                        <div><Field name="nombre" type="text" className="p-inputtext p-component text" label={"Nombre:"} tabIndex="2"/></div>
                                        <div><ErrorMessage name={"nombre"} className="invalid-feedback">{message => <div><small className="p-error">{message}</small></div>}</ErrorMessage></div>
                                    </div>
                                    <div className="p-field p-col p-md-6 p-col-12">
                                        <label htmlFor={"correo"} className="text textMarca">Email:</label>
                                        <div><Field name="correo" className="p-inputtext p-component text" type="email" label={"Email"} tabIndex="1"/></div>
                                        <div><ErrorMessage name={"correo"} >{message => <div><small className="p-error">{message}</small></div>}</ErrorMessage></div>
                                    </div>                                    
                                </div>
                                <div className="p-formgrid p-grid">
                                    
                                    <div className="p-field p-col p-md-6 p-col-12">
                                        <label htmlFor={"rol"} className="text textMarca">Rol:</label>
                                        <Dropdown 
                                            value={rol} 
                                            name="rol"
                                            options={rolOptions} 
                                            onChange={onRolChenge} 
                                            optionLabel="" 
                                            placeholder="Select a Rol" 
                                        />
                                        <div><ErrorMessage name={"rol"} >{message => <div><small className="p-error">{message}</small></div>}</ErrorMessage></div>
                                    </div> 
                                </div>
                            </div>
                            <div className="row">
                                <div className={"center"} >
                                    <Button label="Guardar" type="submit" className="p-button-rounded p-mr-2 p-mb-2 buttonColor text" />
                                </div>
                            </div>
                        </form>
                    )}
                </Formik> 
       </div>
   );
}
const validationSchema = yup.object().shape({
    correo: yup.string().required("Email de usuario requerido."),
    nombre: yup.string().required("Nombre de usuario requerido."),
});
const mapStateToProps = (rootReducer) => {
    return rootReducer.proyect;
};
export default connect(mapStateToProps, proyectAction)(AddUser);